import React, { useMemo, useContext, useState } from "react";
import EquipmentImageWithLoader from "./EquipmentImageWithLoader";
import { FaCheck } from "react-icons/fa";
import { EquipmentContext } from "../useContext/context";

const EquipmentTile = ({ equipment, onDeviceExpand, is_child }) => {
    const { categories_selected, setCategoriesSelected } =
        useContext(EquipmentContext);

    const onSelectEquipment = () => {
        if (is_child) {
            if (!categories_selected?.includes(equipment?.category_id)) {
                return;
            }
            onDeviceExpand(equipment);
        } else {
            onDeviceExpand(equipment);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onSelectEquipment();
        }
    };

    const memoizedFeaturePoints = useMemo(() => {
        return JSON.parse(equipment.feature_points);
    }, [equipment.feature_points]);

    return (
        <div
            className="eqp-col"
            onClick={onSelectEquipment}
            tabIndex="0"
            role="button"
            onKeyDown={handleKeyDown}
        >
            <div
                className={`equipment-item ${is_child && !categories_selected?.includes(equipment?.category_id) ? "child-eqp" : ""}`}
            >
                {!!equipment.promotion_text && (
                    <div className="popular-tag">
                        <p>{equipment.promotion_text}</p>
                    </div>
                )}
                <div className={`eqp-img`}>
                    <EquipmentImageWithLoader id={equipment.id} />
                </div>
                <div className="eqp-info">
                    <p className="eqp-name">{equipment.equipment_name}</p>
                </div>
                {equipment.feature_points && (
                    <div className={`eqp-feature-points`}>
                        {Object.keys(memoizedFeaturePoints).map(
                            (key) =>
                                memoizedFeaturePoints[key] && (
                                    <p className="feature-point">
                                        <FaCheck /> {memoizedFeaturePoints[key]}
                                    </p>
                                ),
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default EquipmentTile;
